import React, { useEffect, useState } from 'react';
import BackButton from "../../../Components/BackButton";
import TitlePages from "../../../Components/TitlePages";
import axios from 'axios';
import {
  Container,
  SizeContainer,
  Title,
  MainContainer,
  ButtonsDiv,
  ButtonCompanies,
  ButtonDeleteCompanies,
  ButtonAddCompanies,
  InputAddIndustry,
  ContainerStock,
} from "./style";
import Loading from '../../../Components/Loading';

const SetupBaseIndustry = () => {
  const [industries, setIndustries] = useState(null)
  const [loading, setLoading] = useState(false)
  const [showInputToAddIndustry, setShowInputToAddIndustry] = useState(false)
  const [nameIndustry, setNameIndustry] = useState('')

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  async function handleAddIndustry() {
    if (nameIndustry.trim().length === 0) return
    try {
      setLoading(true)
      await api.post(`/api/industria/cadastrarIndustriaBase`, {
        nome: nameIndustry
      })
      setShowInputToAddIndustry(false)
      fetchIndustries()

    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }

  }

  async function fetchIndustries() {
    try {
      api.get(`/api/industria/listarBase`)
        .then(response => setIndustries(response.data))
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    fetchIndustries()
  }, [])

  return (
    <Container>
      <SizeContainer>
        <TitlePages text="Setup Base Indústrias" />
        <BackButton path="/menuIndustry" />

        <Title>
          Número de Indústrias na base <span>{industries?.length ?? 0}</span>
        </Title>
        <MainContainer>
          <ButtonsDiv >
            <ButtonAddCompanies disabled={loading} onClick={() => setShowInputToAddIndustry(!showInputToAddIndustry)} >+</ButtonAddCompanies>
          </ButtonsDiv>
          {
            showInputToAddIndustry ? (
              <>
                <ContainerStock>
                  <ButtonsDiv>
                    {loading ? (
                      <Loading style={{
                        height: 100
                      }} />
                    ) : (
                      <>
                        <ButtonCompanies style={{ background: "#fff" }}><InputAddIndustry name={nameIndustry} onChange={e => setNameIndustry(e.target.value)} placeholder="Nome da industria" type="text" /></ButtonCompanies>
                        <ButtonDeleteCompanies onClick={() => handleAddIndustry()} >&#9989;</ButtonDeleteCompanies>
                      </>
                    )

                    }
                  </ButtonsDiv>
                </ContainerStock>

              </>
            ) : null

          }

          <span>Indústrias na base</span>
          {industries?.length === 0 ? (
            <div>
              <span style={{ fontSize: 16 }}>Nenhuma industria cadastrada na base.</span>
            </div>
          ) : (
            industries?.map((industry, k) => {
              return (
                <div key={k}>
                  <ButtonsDiv  >
                    <ButtonCompanies onClick={() => { }} >{industry.nome}</ButtonCompanies>
                  </ButtonsDiv>
                </div>
              )
            })
          )
          }
        </MainContainer>
      </SizeContainer >
    </Container >
  );
};
export default SetupBaseIndustry;
